export async function PostJavadexSeen(userId: string, imageName: string) {
    const url = `${process.env.REACT_APP_API_URL}:8061/jutge/javadex/seen`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id_usuari: userId, image: imageName })
        });

        return response.ok;
    } catch (e) {
        console.error("PostJavadexSeen error:", e);
        return false;
    }
}
